import { Outlet } from 'react-router-dom';
import { useUIStore } from '@/stores/uiStore';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useDeploysLiveSync } from '@/features/deploys/hooks/useDeploysLiveSync';


export function MainLayout() {
  const { sidebarOpen, setSidebarOpen } = useUIStore();
  // Una sola conexión por sesión: mantiene tabla, dashboard, aprobaciones y wizard al día con
  // cualquier cambio de deploys, venga de esta pestaña, de otra o de otro usuario (2026-09-27).
  useDeploysLiveSync();

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Desktop sidebar - always visible */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/50 md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="fixed inset-y-0 left-0 z-50 md:hidden">
            <Sidebar onNavigate={() => setSidebarOpen(false)} />
          </div>
        </>
      )}

      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
